import React from 'react';
import { withHousehold } from 'Context/HouseholdContext';
import DefinedPensionPlans from '../Sections/DefinedPensionPlans';
import SocialSecurityBenefits from '../Sections/SocialSecurityBenefits';
import Navigator from '../UI/Navigator';

const SSIAndPensions = () => (
  <Navigator>
    <DefinedPensionPlans />
    <SocialSecurityBenefits />
  </Navigator>
);

export default withHousehold(SSIAndPensions);
